import React from 'react'

import { Text, pluralize } from '@sketch/components'
import { WorkspacePermissionGroupFragment } from '@sketch/gql-types'

import {
  MemberIcon,
  MemberIconGroup,
  TextWrapper,
  Wrapper,
} from './PermissionGroupItem.styles'

export interface PermissionGroupItemProps {
  className?: string
  permissionGroup: WorkspacePermissionGroupFragment
}

const PermissionGroupItem = (props: PermissionGroupItemProps) => {
  const { className, permissionGroup } = props

  return (
    <Wrapper className={className} data-testid="permission-group-item">
      <MemberIconGroup>
        <MemberIcon>
          {permissionGroup.name
            .split(/-| /)
            .map(a => a[0])
            .splice(0, 2)
            .join('')}
        </MemberIcon>
      </MemberIconGroup>

      <TextWrapper>
        <Text.H1 textStyle="prominent.secondary.E" $reset>
          {permissionGroup.name}
        </Text.H1>
        <Text textStyle="copy.quaternary.standard.D">
          Group • {permissionGroup.members.meta.totalCount}{' '}
          {pluralize(
            'Member',
            'Members',
            permissionGroup.members.meta.totalCount
          )}
        </Text>
      </TextWrapper>
    </Wrapper>
  )
}

export default PermissionGroupItem
